/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DocumentDto } from '@bo-client/shared/models/documentDto';

export class TenantDto {
  id?: string = '';
  displayName?: string = '';
  senderAddress?: string;
  senderAddressCommissioning?: string;
  bccAddress?: string;
  deleteAddress?: string;
  logoUrl?: string;

  documentStorageLocation?: string;
  localStorageLocation?: string;
  canOrderAutomatically?: boolean;
  sendMailByDeleteOrderRequest?: boolean;
  uskBaseUrl?: string;
  offerConfirmationUrl?: string;
  conversationClientUrl?: string;
  hostName?: string;

  mailSettings?: MailSettings;
  supplyAppointmentDays?: number;
  mwstFromBackend?: boolean;
  theme?: Theme;
  chimneySweepFeedbackMail?: string;
  backofficeUrl?: string;
  priceCalculatorType?: string;
}

export interface MailSettings {
  id?: number;
  senderAddress?: string;
  bccAddress?: string;
  templates?: MailTemplate[];
}

export interface MailTemplate {
  id?: number;
  htmlContent?: string;
  documentContent?: DocumentDto;
  type?: string;
  format?: string;
}

export class Theme {
  id?: number;
  logoUrl?: string = '';
  primaryColor?: string = '#333333';
  secondaryColor?: string = '#ffffff';
  tertiaryColor?: string = '#333333';
}
